import { render } from "./Agente.vue?vue&type=template&id=67e79cd5&scoped=true"
import script from "./Agente.vue?vue&type=script&lang=ts"
export * from "./Agente.vue?vue&type=script&lang=ts"

import "./Agente.vue?vue&type=style&index=0&id=67e79cd5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67e79cd5"

export default script